// @flow
import type { BlocContent } from 'types/NewsletterBloc';
import type { RawRencontreSimpleType, RencontreArticleType } from 'types/Rencontre';

import { getPlaceholder } from 'utils/assetsUtils';

export const nullArticle = {
  slug: '',
  link: '',
  date: new Date(),
  modified: new Date(),
  label: {
    name: '',
    slug: ''
  },
  caption: '',
  title: 'Default title',
  srcset: {},
  illustration: getPlaceholder(),
  illustration_video:[],
  blocs: [],
  tags: [],
  twitter: 0,
  facebook: 0,
  sidebar: [],
  meta_title: '',
  meta_description: '',
  ffr_url_canonical: '',
  redirection: '',
  rencontre_liee: '',
  rencontre_details: null,
  typeFlow: 'ArticleType',
};

export const nullLoadingArticle = {
  ...nullArticle,
  title: 'Chargement de l\'article',
  illustration: getPlaceholder(),
  blocs: [
    {
      tagName: 'p',
      type: 'element',
      attributes: [],
      children: [
        {
          type: 'text',
          text: 'Chargement du contenu de l\'article...'
        }
      ]
    }
  ],
};

export const nullFailureArticle = {
  ...nullArticle,
  title: 'Oups',
  illustration: getPlaceholder(),
  blocs: [
    {
      tagName: 'p',
      type: 'element',
      attributes: [],
      children: [
        {
          type: 'text',
          text: 'Un problème est survenue, merci de réactualiser la page.'
        }
      ]
    }
  ],
};

export const nullCategory = {
  id: 0,
  name: '',
  slug: ''
};

export const nullCategoryArticle = {
  id: 0,
  name: '',
  slug: '',
  items: []
};

export type SourceSetType = {
  [key: string]: {
    src: string,
    width: number,
    height: number,
  },
};

export type ArticleType = {
  slug: string,
  typeFlow: string,
  link: string,
  date: Date | string,
  modified: Date | string,
  label: {
    name: string,
    slug: string
  },
  caption: string,
  title: string,
  srcset: SourceSetType,
  illustration: string,
  illustration_video: BlocContent[],
  blocs: BlocContent[],
  tags: {
    id: number,
    name: string,
    slug: string,
    source: string,
  }[],
  twitter: number,
  facebook: number,
  sidebar: BlocContent[],
  ffr_url_canonical: string,
  meta_title: string,
  meta_description: string,
  redirection: string,
  rencontre_liee: ?string,
  rencontre_details: ?RencontreArticleType,
};

export type RawArticleType = {
  id: number,
  date: string,
  data_gmt: string,
  featured_media:
    | number
    | {
        id: number,
        src: string,
        legend: string,
        alt: string,
        width: number,
        height: number,
        sizes: Object
      },
  label: {
    id: number,
    name: string,
    slug: string
  },
  guid: { rendered: string },
  modified: string,
  modified_gmt: string,
  categories: number[],
  content: {
    rendered: string,
    protected: boolean,
    data: BlocContent[]
  },
  excerpt: {
    rendered: string,
    protected: boolean
  },
  featured_video: {
    rendered: string,
    data: BlocContent[]
  },
  format: string,
  link: string,
  meta: Object,
  ping_status: string,
  slug: string,
  sticky: boolean,
  tags_list: {
    id: number,
    name: string,
    slug: string,
    source: string,
  }[],
  template?: string,
  title: Object,
  meta_title: string,
  meta_description: string,
  type: string,
  sidebar_content: {
    data: BlocContent[]
  },
  redirect: {
    type: string,
    postid: string,
    title: string,
    url: string,
  },
  rencontre: ?RawRencontreSimpleType,
};

export type CategoryType = {
  id: number,
  name: string,
  slug: string
};

export type RawCategoryType = {
  id: number,
  count: number,
  description: string,
  link: string,
  name: string,
  slug: string,
  taxonomy: string,
  parent: number,
  meta: any[],
  _links: {
    self: Array<{
      href: string
    }>,
    collection: Array<{
      href: string
    }>,
    about: Array<{
      href: string
    }>,
    'wp:post_type': Array<{
      href: string
    }>,
    curies: Array<{
      name: string,
      href: string,
      templated: boolean
    }>
  }
};

export type CategoryArticleType = {
  id: number,
  name: string,
  slug: string,
  items: ArticleType[]
};

export type RawCategoryArticleType = {
  id: number,
  count: number,
  description: string,
  link: string,
  name: string,
  slug: string,
  taxonomy: string,
  parent: number,
  meta: Array<any>,
  _links: {
    self: Array<{
      href: string
    }>,
    collection: Array<{
      href: string
    }>,
    about: Array<{
      href: string
    }>,
    'wp:post_type': Array<{
      href: string
    }>,
    curies: Array<{
      name: string,
      href: string,
      templated: boolean
    }>
  },
  items: ArticleType[]
};
